var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoPlayer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1453_6033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8648 8.47046C12.4337 8.47046 12.0791 8.3314 11.801 8.05327C11.5229 7.77514 11.3838 7.42749 11.3838 7.0103C11.3838 6.59311 11.5229 6.24545 11.801 5.96733C12.0791 5.6753 12.4337 5.52928 12.8648 5.52928C13.282 5.52928 13.6297 5.6753 13.9078 5.96733C14.1859 6.24545 14.325 6.59311 14.325 7.0103C14.325 7.42749 14.1859 7.77514 13.9078 8.05327C13.6297 8.3314 13.282 8.47046 12.8648 8.47046Z",
    fill: "#1D7777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.325 16.5587L14.325 11.4116C14.325 10.5994 13.6666 9.94104 12.8544 9.94104C12.0422 9.94104 11.3838 10.5994 11.3838 11.4116L11.3838 16.5587C11.3838 17.3709 12.0422 18.0293 12.8544 18.0293C13.6666 18.0293 14.325 17.3709 14.325 16.5587Z",
    fill: "#1D7777"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1453_6033"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.7059,
    height: 14.7059,
    fill: "white",
    transform: "translate(19.8535 5.14697) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoPlayer);
export default __webpack_public_path__ + "static/media/info_player.209fc7e5fc6ae69a3d836969697b6e59.svg";
export { ForwardRef as ReactComponent };